import React, { useState, useRef } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Card } from './ui/Card';
import { CameraIcon, UserIcon, CheckCircleIcon } from 'lucide-react';
interface NameEntryProps {
  onNext: (firstName: string, lastName: string, photo: string) => void;
}
export function NameEntry({
  onNext
}: NameEntryProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [photo, setPhoto] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handlePhotoCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => {
      setPhoto(ev.target?.result as string);
    };
    reader.readAsDataURL(file);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (firstName.trim() && lastName.trim()) {
      onNext(firstName.trim(), lastName.trim(), photo);
    }
  };
  const canSubmit = firstName.trim() && lastName.trim();
  return <div className="min-h-screen flex items-center justify-center p-4 bg-zinc-950" data-id="element-75">
      <Card className="w-full max-w-md" data-id="element-76">
        <h2 className="text-3xl font-bold text-white mb-1 text-center" data-id="element-77">
          WHO ARE YOU?
        </h2>
        <p className="text-gray-400 mb-6 text-center text-sm" data-id="element-78">
          Enter your name and snap a photo to begin
        </p>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-79">
          {/* Photo capture — prominent, at top */}
          <div className="flex flex-col items-center mb-2" data-id="element-80">
            <button type="button" onClick={() => fileInputRef.current?.click()} className="relative w-24 h-24 rounded-full border-2 border-dashed border-zinc-600 hover:border-orange-500 transition-colors flex items-center justify-center overflow-hidden bg-zinc-800 active:scale-95" data-id="element-81">
              {photo ? <>
                  <img src={photo} alt="Profile" className="w-full h-full object-cover" data-id="element-82" />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity" data-id="element-83">
                    <CameraIcon className="w-6 h-6 text-white" data-id="element-84" />
                  </div>
                </> : <div className="flex flex-col items-center gap-1" data-id="element-85">
                  <CameraIcon className="w-8 h-8 text-zinc-500" data-id="element-86" />
                  <span className="text-zinc-500 text-xs" data-id="element-87">Photo</span>
                </div>}
            </button>
            {photo && <div className="flex items-center gap-1 mt-2 text-green-400 text-xs" data-id="element-88">
                <CheckCircleIcon className="w-3 h-3" data-id="element-89" /> Photo captured
              </div>}
            <input ref={fileInputRef} type="file" accept="image/*" capture="user" onChange={handlePhotoCapture} className="hidden" data-id="element-90" />
          </div>

          <div className="grid grid-cols-2 gap-3" data-id="element-91">
            <Input placeholder="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} autoFocus autoComplete="given-name" data-id="element-92" />
            <Input placeholder="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} autoComplete="family-name" data-id="element-93" />
          </div>

          <Button type="submit" className="w-full" size="lg" disabled={!canSubmit} data-id="element-94">
            ENTER THE ARENA
          </Button>
        </form>
      </Card>
    </div>;
}